angular.module('unica_user.user_services')

.factory('UserListService', function ($http, getBaseApiURL) {

	var userListService = {};


	userListService.list = function (limit, offset)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/user/list',
			data: {
				limit: limit,
				offset: offset
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.users;
			}

		});
	};


	userListService.listByRole = function (role, sub_role)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/user/list-by-role',
			data: {
				role: role,
				sub_role: sub_role
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.users;
			}

		});
	};


	userListService.listAgentsByAgencyCode = function (agency_code, subcategories)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/user/list-agents-by-agency-code',
			data: {
				agency_code: agency_code,
				subcategories: subcategories
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.users;
			}

		});
	};


	userListService.listByRoleAndSearch = function (role, sub_role, query)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/user/list-by-role-search',
			data: {
				role: role,
				sub_role: sub_role,
				search: query
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.users;
			}

		});
	};


	userListService.listSubnet = function (id, usersToExclude, invitationListId)
	{
		var data = { };

		if ( usersToExclude ) {
			data.users_to_exclude = usersToExclude;
		}

		if ( invitationListId ) {
			data.invitation_list_id = invitationListId;
		}

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/user/get-subnet/' + id,
			data: data
		}).then(function(result) {

			if ( result ) {
				return result.data.users;
			}

		});
	};


	userListService.get = function (userId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/user/detail/' + userId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				result.data.user.dob = new Date(result.data.user.dob * 1000);

				if ( typeof result.data.user.props.doc_emission_date !== "undefined" ) {
					result.data.user.props.doc_emission_date = moment( result.data.user.props.doc_emission_date ).toDate();
				}
				if ( typeof result.data.user.props.doc_expiration_date !== "undefined" ) {
					result.data.user.props.doc_expiration_date = moment( result.data.user.props.doc_emissdoc_expiration_dateion_date ).toDate();
				}

				result.data.user.privacy_date = new Date(result.data.user.privacy_date * 1000);

				return result.data.user;
			}

		});
	};


	userListService.search = function (search, usersToExclude, invitationListId)
	{
		var data = {
			search: search
		};

		if ( usersToExclude ) {
			data.users_to_exclude = usersToExclude;
		}

		if ( invitationListId ) {
			data.invitation_list_id = invitationListId;
		}

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/user/search',
			data: data
		}).then(function(result) {

			if ( result ) {
				return result.data.users;
			}

		});
	};


	userListService.simpleAdvancedSearch = function (searchData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/user/simple-advanced-search',
			data: searchData
		}).then(function(result) {

			if ( result ) {
				return result.data.users;
			}

		});
	};


	userListService.advancedSearch = function (searchData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/user/advanced-search',
			data: searchData
		}).then(function(result) {

			if ( result ) {
				return result.data.users;
			}

		});
	};


	userListService.exportSubnet = function (userId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/subnet-list/' + userId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};


	return userListService;
});